import { Operator } from './operator';

export class LessThanInclusive implements Operator {
	public evaluate(value: number, target: number): boolean {
		return value <= target;
	}
}
